(function () {
    // Define your map logic
    window.GoogleMapBlock = (() => {
        const initBlock = (el) => {
            const lat = parseFloat(el.dataset.lat);
            const lng = parseFloat(el.dataset.lng);
            const zoom = parseInt(el.dataset.zoom, 10) || 10;
            const mapId = "notTheRealId"; // Replace this with your actual Map ID

            const map = new google.maps.Map(el, {
                center: { lat, lng },
                zoom: zoom,
                mapId: mapId,
                clickableIcons: false
            });

            if (google.maps.marker && google.maps.marker.AdvancedMarkerElement) {
                new google.maps.marker.AdvancedMarkerElement({
                    map: map,
                    position: { lat, lng }
                });
            } else {
                console.error("AdvancedMarkerElement is not available. Ensure the 'marker' library is loaded.");
            }
        };

        const initAll = () => {
            document.querySelectorAll('[data-google-map]').forEach(initBlock);
        };

        return { initAll };
    })();

    // Google's required global callback — triggered when script loads
    window.initMap = function () {
        if (window.GoogleMapBlock && typeof GoogleMapBlock.initAll === "function") {
            GoogleMapBlock.initAll();
        } else {
            console.warn("Waiting for GoogleMapBlock...");
            setTimeout(window.initMap, 50);
        }
    };
})();
